import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { NGXLogger } from 'ngx-logger';
import {
  Hospital,
  ContactInformation,
  InformationCategory,
  InformationPage, SyncContainer, News
} from '@nsk-app/models';
import { map, timeout } from 'rxjs/operators';
import { AnalyticsEvent } from '@nsk-app/models/analyticsEvent';
import { AppRegistration } from '@nsk-app/models/appRegistration';
import { Capacitor } from '@capacitor/core';
import { ConfigurationService } from '@nsk-app/services/configuration.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  private url = 'https://niels-app-be.niels-stensen-kliniken.de/api/';
  private imageCache: Cache = null;
  private blobCache: Map<string, string> = new Map<string, string>();

  constructor(
    private http: HttpClient,
    private logger: NGXLogger
  ) {
  }

  getTopicDatabase(topicId: number): Observable<SyncContainer> {
    return this.http.get<SyncContainer>(this.url + 'sync/' + topicId);
  }

  getHospitals(): Observable<Hospital[]> {
    return this.http.get<Hospital[]>(this.url + 'sites');
  }

  getTopic(id: number): Observable<any> {
    return this.http.get<any>(this.url + 'topic/' + id);
  }

  getContact(hospitalId: number): Observable<ContactInformation> {
    return this.http.get<ContactInformation>(this.url + 'sites/' + hospitalId + '/contact');
  }

  getInformationCategories(): Observable<InformationCategory[]> {
    return this.http.get<InformationCategory[]>(this.url + 'information');
  }

  getInformation(informationId: number): Observable<InformationPage> {
    return this.http.get<InformationPage>(this.url + 'information/' + informationId);
  }

  getNews(topicId: number): Observable<News[]> {
    return this.http.get<News[]>(this.url + 'news/' + topicId);
  }

  async getLastUpdate(): Promise<Date> {
    const data = this.http.get<{last_update: string}>(this.url + 'last')
      .pipe(
        map(res => new Date(res.last_update)),
        timeout(750)
      );
    return data.toPromise();
  }

  async registerApp(topic_id: number, push_enabled: boolean, firebase_id: string, tracking_id: string = null): Promise<AppRegistration> {
    const platform = Capacitor.getPlatform();

    if(tracking_id === null){
      const data = this.http.post<AppRegistration>(this.url + 'registration',{platform, topic_id, push_enabled, firebase_id});
      return data.toPromise();
    }else{
      const data = this.http.put<AppRegistration>(this.url + 'registration/' + tracking_id,{platform, topic_id, push_enabled, firebase_id});
      return data.toPromise();
    }

  }

  async submitAnalytics(tracking_id: string, events: AnalyticsEvent[]): Promise<Object> {
    if(Capacitor.getPlatform() === 'web'){
      return {};
    }

    return this.http.post(this.url + 'analytics/' + tracking_id,{events}).toPromise();
  }
}
